import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import List from '../../components/Crud/List';
import PayrollsList from './PayrollsList';
import { PayrollViewModel } from '../../models/payroll/PayrollViewModel';

export default function PayrollsIndex() {
  const [isLoading, setIsLoading] = useState(true);
  const [payrolls, setPayrolls] = useState<PayrollViewModel[]>([]);

  const {
    user: { organization },
    isAdmin,
  } = useAuth();

  async function getPayrolls() {
    if (organization) {
      setIsLoading(true);
      const { data } = await api.get(
        `organizations/${organization.id}/payrolls`
      );
      setPayrolls(data.data);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getPayrolls();
  }, [organization]);

  return (
    <List
      isLoading={isLoading}
      title='Folhas'
      withNewAction={false}
      newItemUrl=''
    >
      <PayrollsList payrolls={payrolls} refreshPayrolls={() => getPayrolls()} />
    </List>
  );
}
